import { makeStyles } from '@material-ui/core'
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    height: '100%',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  card: {
    minWidth: 275,
    boxShadow: 'none',
    backgroundColor: 'inherit',
    textAlign: "center",
    border: '0px',
  },
  cardContent: {
    backgroundColor: 'inherit',
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  img:{
    height:'35vh',
    marginTop:'2em',
    marginBottom:'2em',
  },
  buttonReturn: {
    textTransform: 'capitalize',
    paddingLeft: '3rem',
    paddingRight: '3rem',
    lineHeight: '1.5rem',
    letterSpacing: '0.1rem',
    width: '100%',
  },
}));

export default useStyles;
